import { ConsentBanner } from '@/components/consent/consent-banner'
import { GoogleAnalyticsLoader } from '@/components/consent/google-analytics-loader'
import { ThemeProvider } from '@/components/theme-provider'

type AppProvidersProps = {
  children: React.ReactNode
}

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <ThemeProvider defaultTheme="dark" storageKey="podium-theme">
      {children}
      <ConsentBanner />
      <GoogleAnalyticsLoader />
    </ThemeProvider>
  )
}
